import select2 from 'select2';

select2();

$(document).ready(() => {
  $('select').each(function () {
    $(this).select2({
      minimumResultsForSearch: this.dataset.updateSearchResult || 0
    });
  });
});
